"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
function default_1(confirm) {
    confirm({
        description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('인증에 어려움을 겪고계신가요?'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('도움이 필요하시면 트위터 @fondee_official 로 문의주세요.')] })),
        cancellationButtonProps: { style: { display: 'none' } },
    });
}
exports.default = default_1;
